import React from 'react';
import useCallDuration, { formatCallDuration } from './useCallDuration';
import { toAbsoluteUrl } from '../../../../_ens/_helpers';
import './CallTopBar.scss';

/**
 * Barra superiore della videochiamata guest STAI2.
 * Raggruppa in un'unica barra allineata gli elementi che prima flottavano
 * separati: nome del partecipante remoto (sinistra), durata della chiamata
 * (centro) e schermo intero (destra). La grafica dei singoli elementi resta
 * quella già in uso nel progetto.
 *
 * Props:
 * - participantName: nome del partecipante remoto (nascosto se vuoto)
 * - durationRunning: se il timer della durata deve essere attivo
 * - isFullScreen / onToggleFullScreen: stato e toggle dello schermo intero
 * - compact: versione ridotta (solo durata + schermo intero), per box stretti
 */
const CallTopBar = ({
  participantName,
  durationRunning = true,
  isFullScreen = false,
  onToggleFullScreen,
  compact = false
}) => {
  const seconds = useCallDuration(durationRunning);
  const duration = formatCallDuration(seconds);
  const fullScreenLabel = isFullScreen ? 'Esci da schermo intero' : 'Attiva schermo intero';

  return (
    <div className={`stai2-call-topbar ${compact ? 'stai2-call-topbar--compact' : ''}`}>
      <div className="stai2-call-topbar__side stai2-call-topbar__side--left">
        {participantName && (
          <div className="stai2-guest-name-label" title={participantName}>
            {participantName}
          </div>
        )}
      </div>

      <div className="stai2-call-topbar__side stai2-call-topbar__side--center">
        {durationRunning && (
          <div
            className="stai2-call-topbar__duration"
            role="timer"
            aria-live="off"
            aria-label={`Durata chiamata ${duration}`}
          >
            <span className="stai2-call-topbar__duration-label">⏱ Durata chiamata: </span>
            <span className="stai2-call-topbar__duration-value">{duration}</span>
          </div>
        )}
      </div>

      <div className="stai2-call-topbar__side stai2-call-topbar__side--right">
        {onToggleFullScreen && (
          <button
            type="button"
            className="screen-control stai2-call-topbar__fullscreen"
            onClick={onToggleFullScreen}
            aria-label={fullScreenLabel}
            aria-pressed={isFullScreen}
            title={fullScreenLabel}
          >
            {isFullScreen ? (
              <img alt="minimize" src={toAbsoluteUrl('/media/svg/icons/Call/minimize.svg')} />
            ) : (
              <img alt="fullscreen" src={toAbsoluteUrl('/media/svg/icons/Call/fullscreen.svg')} />
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default CallTopBar;
